import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=6591fe94&scoped=true"
import script from "./Voucher.vue?vue&type=script&lang=js"
export * from "./Voucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6591fe94",
  null
  
)

export default component.exports